var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Accordion, Button, ConfirmDialog, InlineNotification, Status, Text, TextInput } from '@ui';
import { connectionErrorMessage } from '../shared/connectionErrors';
import { FAILURE_REASONS } from '../shared/constants';
import { translatorFor } from '../shared/i18n';
import { errorResponse } from '../shared/types';
const t = translatorFor('status_card');
const SECRET_MASK = '••••••••';
const CONNECTED_COLOR = 'green-500';
export function maskedSecret(last4) {
    return `${SECRET_MASK}${last4 !== null && last4 !== void 0 ? last4 : ''}`;
}
export function StatusCard({ credentialStatus, onReplaceSecret, onDisconnect }) {
    var _a, _b;
    const [expanded, setExpanded] = useState(false);
    const [replacing, setReplacing] = useState(false);
    const [newSecret, setNewSecret] = useState('');
    const [tenantId, setTenantId] = useState('');
    const [tenantIdRequired, setTenantIdRequired] = useState(false);
    const [saving, setSaving] = useState(false);
    const [confirmingDisconnect, setConfirmingDisconnect] = useState(false);
    const [disconnecting, setDisconnecting] = useState(false);
    const [error, setError] = useState(null);
    const cancelReplace = () => {
        setReplacing(false);
        setNewSecret('');
        setTenantId('');
        setTenantIdRequired(false);
        setError(null);
    };
    const saveSecret = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        setSaving(true);
        setError(null);
        try {
            yield onReplaceSecret(Object.assign({ clientId: (_a = credentialStatus.clientId) !== null && _a !== void 0 ? _a : '', clientSecret: newSecret.trim() }, (tenantIdRequired ? { serviceTitanTenantId: tenantId.trim() } : {})));
            cancelReplace();
        }
        catch (err) {
            const reason = (_b = errorResponse(err)) === null || _b === void 0 ? void 0 : _b.reason;
            if (reason === FAILURE_REASONS.TENANT_CLAIM_MISSING)
                setTenantIdRequired(true);
            setError(connectionErrorMessage(reason));
        }
        finally {
            setSaving(false);
        }
    });
    const disconnect = () => __awaiter(this, void 0, void 0, function* () {
        setDisconnecting(true);
        setError(null);
        try {
            yield onDisconnect();
        }
        catch (_a) {
            setError(t('disconnect_failed'));
            setDisconnecting(false);
        }
    });
    return (React.createElement(Accordion, { variant: "section", title: React.createElement("span", { className: "service-titan-settings__card-header" },
            t('title'),
            React.createElement(Status, { label: t('connected'), color: CONNECTED_COLOR })), isExpanded: expanded, onToggle: setExpanded },
        React.createElement("div", { className: "service-titan-settings__accordion-body" },
            React.createElement(Text, { variant: "body", as: "p", className: "service-titan-settings__muted" }, t('tenant', { tenantId: (_a = credentialStatus.serviceTitanTenantId) !== null && _a !== void 0 ? _a : '' })),
            React.createElement("div", { className: "service-titan-settings__fields" },
                React.createElement(TextInput, { id: "service-titan-status-client-id", label: t('client_id_label'), readOnly: true, value: (_b = credentialStatus.clientId) !== null && _b !== void 0 ? _b : '' }),
                replacing ? (React.createElement(React.Fragment, null,
                    React.createElement(TextInput, { id: "service-titan-status-new-secret", type: "password", label: t('new_secret_label'), value: newSecret, onChange: (event) => setNewSecret(event.target.value) }),
                    tenantIdRequired && (React.createElement(TextInput, { id: "service-titan-status-tenant-id", label: t('tenant_id_label'), required: true, value: tenantId, onChange: (event) => setTenantId(event.target.value) })))) : (React.createElement("div", { className: "service-titan-settings__secret-row" },
                    React.createElement(TextInput, { id: "service-titan-status-secret", label: t('client_secret_label'), readOnly: true, value: maskedSecret(credentialStatus.clientSecretLast4) }),
                    React.createElement(Button, { variant: "secondary", onClick: () => setReplacing(true) }, t('replace'))))),
            error && React.createElement(InlineNotification, { variant: "error" }, error),
            React.createElement("div", { className: "service-titan-settings__actions" },
                replacing && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { variant: "primary", disabled: saving || newSecret.trim() === '' || (tenantIdRequired && tenantId.trim() === ''), onClick: () => {
                            void saveSecret();
                        } }, saving ? t('saving') : t('save_secret')),
                    React.createElement(Button, { variant: "tertiary", disabled: saving, onClick: cancelReplace }, t('cancel')))),
                !replacing && (React.createElement(Button, { variant: "danger", disabled: disconnecting, onClick: () => setConfirmingDisconnect(true) }, t('disconnect')))),
            React.createElement(ConfirmDialog, { isOpen: confirmingDisconnect, title: t('disconnect_confirm_title'), description: t('disconnect_confirm_description'), confirmLabel: t('disconnect'), cancelLabel: t('cancel'), confirmVariant: "danger", loading: disconnecting, onConfirm: () => {
                    void disconnect();
                }, onCancel: () => setConfirmingDisconnect(false) }))));
}
export default StatusCard;
